var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.4597 3.9375L9.70972 10.125L2.95972 3.9375H16.4597Z",
    fill: "#6C727F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.54507 3.55741C2.75499 3.3284 3.11081 3.31293 3.33982 3.52285L9.70972 9.36193L16.0796 3.52285C16.3086 3.31293 16.6645 3.3284 16.8744 3.55741C17.0843 3.78641 17.0688 4.14223 16.8398 4.35215L10.0898 10.5397C9.87476 10.7368 9.54468 10.7368 9.32963 10.5397L2.57963 4.35215C2.35062 4.14223 2.33515 3.78641 2.54507 3.55741Z",
    fill: "#154063"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.39722 3.9375C2.39722 3.62684 2.64906 3.375 2.95972 3.375H16.4597C16.7704 3.375 17.0222 3.62684 17.0222 3.9375V13.5C17.0222 13.7984 16.9037 14.0845 16.6927 14.2955C16.4817 14.5065 16.1956 14.625 15.8972 14.625H3.52222C3.22385 14.625 2.9377 14.5065 2.72672 14.2955C2.51574 14.0845 2.39722 13.7984 2.39722 13.5V3.9375ZM3.52222 4.5V13.5H15.8972V4.5H3.52222Z",
    fill: "#154063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89381 8.61981C9.10379 8.84876 9.0884 9.20459 8.85945 9.41456L3.5157 14.3153C3.28674 14.5253 2.93092 14.5099 2.72094 14.281C2.51097 14.052 2.52635 13.6962 2.75531 13.4862L8.09906 8.58544C8.32801 8.37547 8.68383 8.39085 8.89381 8.61981Z",
    fill: "#154063"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5256 8.61981C10.7356 8.39085 11.0914 8.37547 11.3204 8.58544L16.6641 13.4862C16.8931 13.6962 16.9085 14.052 16.6985 14.281C16.4885 14.5099 16.1327 14.5253 15.9037 14.3153L10.56 9.41456C10.331 9.20459 10.3157 8.84876 10.5256 8.61981Z",
    fill: "#154063"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.e53ed2f1aa93479d2e0eb13f4cd81622.svg";
export { ForwardRef as ReactComponent };